import { useMediaQuery } from '@material-ui/core';

const useIsTablet = () => {
  const isTablet = useMediaQuery('(max-width: 1024px) and (min-width: 600px)');
  return isTablet;
};

export default useIsTablet;
